import { buildDiagnosisResult } from './builders';
import type { DiagnosisResultContent } from './types';

/** PACZ（究極の安心旅行者） */
const paczContent: DiagnosisResultContent = {
  code: 'PACZ',
  name: '究極の安心旅行者',
  catchphrase: 'ツアーパッケージで全部お任せ！安心安全リスクゼロの旅行者',
  rarity: 4,
  style:
    '「安心して心からくつろぐ」ために、徹底的に備える計画派。トラブルの芽を事前に潰し、評判の良い宿・移動手段・スポットだけを選ぶ。アクティブに動ける体力はあるが、無理はせず、癒しと安心を最優先。保険・予約・代替案まで用意し、何が起きても動じない。同行者にとって最も頼れる「旅の安全基地」タイプ。',
  strengths: [
    { lead: '危機管理が万全', text: '予約・保険・代替案まで備え、トラブルを未然に防げる。' },
    { lead: '安心感を共有できる', text: '同行者が不安なく過ごせるよう先回りで段取りできる。' },
    { lead: 'しっかり休める', text: '癒しを計画に組み込み、旅の疲れを溜めにくい。' },
  ],
  weaknesses: [
    { lead: '冒険が少ない', text: '安全志向が強く、未知の体験を避けてしまいがち。' },
    { lead: '心配性になりやすい', text: 'リスクを考えすぎて、その場を純粋に楽しめないことがある。' },
    { lead: '即興の誘いに弱い', text: '計画外の提案に戸惑い、流れに乗りにくい。' },
  ],
  aaru: [
    { icon: 'coffee', text: '宿の口コミは全部チェック' },
    { icon: 'msg', text: '「念のため予約しておこう」が口癖' },
    { icon: 'camera', text: '常備薬とモバイルバッテリーは必携' },
    { icon: 'coffee', text: '余裕を持った移動時間を確保' },
  ],
  manual: {
    good: '安心材料を一緒に揃える／計画に感謝を伝える',
    ng: '「なんとかなるよ」で準備を軽視する',
    tips: '小さな冒険は「安全が確認できれば」で誘うと乗りやすい',
  },
  compatibility: {
    good: 'PACE（完璧弾丸）／PRCZ（快適派）',
    conflict: 'SALE（爆速即興）／SRLE（食い倒れ冒険）',
    tips: '不安要素を先に解消しておくと安心して動ける',
  },
  destinations: {
    domestic: '北海道（自然と上質宿でゆったり）／伊勢志摩（安心の王道リゾート）',
    overseas: 'ハワイ（治安と環境が安定）／台湾（医療・衛生面が安心）',
  },
};

export const paczDiagnosisResult = buildDiagnosisResult(paczContent);
